/**
 * Card or full-screen loading using the branded rotating Five mark.
 */

import { Card, CardContent } from '@/components/ui/Card';
import { BrandedLoading } from './BrandedLoading';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

export function LoadingState({ message = 'Loading…', fullScreen = false }: LoadingStateProps) {
  const body = <BrandedLoading message={message} iconSize="md" />;

  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">{body}</div>
    );
  }

  return (
    <Card>
      <CardContent className="flex justify-center p-8">{body}</CardContent>
    </Card>
  );
}
